/**
 * INVOICES STORE
 */

import api from "Api";

const state = {
    page: {},
    dashboard_invoices: null,
    invoice: null,
    invoices: JSON.parse(localStorage.getItem("invoices")) || null,
    invoices_filter: {
        search: "",
        company_id: "",
        page_size: 0,
        page_num: 1,
    },
};

// getters
const getters = {};

// actions
const actions = {
    async fetchInvoice({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitInvoice", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitInvoice", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateInvoice", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitInvoice(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateInvoice(state, payload) {
        if (payload.method == "post" && payload.with) {
            state[payload.property].push(payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            if (Array.isArray(payload.with)) {
                payload.with.forEach((x) => {
                    let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == x[payload.pk])];
                    for (const key in x) if (key in curr_item) curr_item[key] = x[key];
                });
            } else {
                let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == payload.with[payload.pk])];
                for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
            }
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            state[payload.property].splice(
                state[payload.property].findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
        }
    },
    resetInvoices(state) {
        state.page = {};
        state.dashboard_invoices = null;
        state.invoice = null;
        state.invoices = JSON.parse(localStorage.getItem("invoices")) || null;
        state.invoices_filter = {
            search: "",
            company_id: "",
            page_size: 0,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
